module.exports = __webpack_public_path__ + "static/media/sentiment_happy.81fe82de.svg";